import { collection, deleteDoc, doc, getDocs, setDoc, updateDoc, db } from "../../../services/firestoreApi";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { v4 as uuidv4 } from 'uuid';
import DropdownBeneficiosLogos from "./DropdownBeneficiosLogos";
import ShowLogosBeneficios from "./ShowLogosBeneficios";
import CustomSpinner from "../../general/CustomSpinner";
import UserContext from "../../user/UserContext";
import { getCoordinates } from "../../../services/beneficiosService";
import AdminPagination, { ITEMS_PER_PAGE } from "./AdminPagination";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

const ADDRESS_FIELDS = [
    ["calle", "Calle"], ["numero", "Número"], ["colonia", "Colonia"],
    ["codigoPostal", "Código postal"], ["municipio", "Municipio"],
    ["estado", "Estado"], ["pais", "País"]
]

const emptyAddress = {
    calle: "", numero: "", colonia: "", codigoPostal: "",
    municipio: "Uruapan", estado: "Michoacán", pais: "México"
}

const buildAddress = item => ADDRESS_FIELDS
    .map(([field]) => item[field])
    .filter(Boolean)
    .join(", ")

const AddressFields = ({ value, onChange }) => ADDRESS_FIELDS.map(([field, label]) => (
    <span key={field}>
        <label className="form-label" >
            {label}

        </label>
        <br />
        <input className="form-control mb-3" name={field} value={value[field] || ""} onChange={onChange} />
        <br />
    </span>

))

const BeneficiosCRUD = () => {

    //datos recibidos de la base de datos 
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    //manejadores para mostrar y ocultar los modales
    const [modalInsertar, setModalInsertar] = useState(false)
    const [modalEditar, setModalEditar] = useState(false)
    const [modalEliminar, setModalEliminar] = useState(false);
    const [modalMapa, setModalMapa] = useState(false);
    const mapaRef = useRef(null)

    //se activan en el on click de los botones
    //insertar, eliminar, editar correspondientemente
    const OpenCLoseModalInsertar = () => {
        setModalInsertar(!modalInsertar)
    }
    const OpenCLoseModalEliminar = () => {
        setModalEliminar(!modalEliminar)
    }
    const OpenCLoseModalEditar = () => {
        setModalEditar(!modalEditar)
    }

    const { loading, setLoading } = useContext(UserContext)

    useEffect(() => {
        if (!modalMapa || !mapaRef.current) return

        const ubicaciones = data
            .map(item => ({ ...item.data(), id: item.id }))
            .filter(item => Number.isFinite(Number(item.latitud)) && Number.isFinite(Number(item.longitud)))
        const mapa = L.map(mapaRef.current).setView([19.4194, -102.0637], 12)
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "&copy; OpenStreetMap contributors"
        }).addTo(mapa)

        const puntos = ubicaciones.map(item => {
            const punto = [Number(item.latitud), Number(item.longitud)]
            L.marker(punto).addTo(mapa).bindPopup(`<strong>${item.title || "Beneficio"}</strong><br>${item.direccion || ""}`)
            return punto
        })

        if (puntos.length > 1) mapa.fitBounds(puntos, { padding: [30, 30] })
        setTimeout(() => mapa.invalidateSize(), 0)

        return () => mapa.remove()
    }, [modalMapa, data])
    //Metodo get para obtener los items de la DB
    const GetItems = async () => {
        setLoading(true)
        const querySnapshot = await getDocs(collection(db, "beneficios"));
        setData(querySnapshot.docs)
        setCurrentPage(1)
        setLoading(false)
    }

    const [itemSeleccionado, setitemSeleccionado] = useState({
        logo: "",
        title: "",
        categoria: "",
        beneficio: "",
        direccion: "",
        map: "",
        especialidad: "",
        ...emptyAddress

    })
    const [editItemSeleccionado, setEditItemSeleccionado] = useState(undefined)
    const SeleccionarUsuario = (item, caso) => {
        const values = item.data()
        setitemSeleccionado({ ...emptyAddress, ...values, calle: values.calle || values.direccion || "" });
        setEditItemSeleccionado(item);
        (caso === "editar") ?
            OpenCLoseModalEditar()
            :
            OpenCLoseModalEliminar()
    }
    const HandleChange = e => {
        const { name, value } = e.target
        setitemSeleccionado((prevState) => ({
            ...prevState,
            [name]: value
        }))
        //console.log(itemSeleccionado)
    }
    // const [imagen, setImagen] = useState(undefined)
    const HandleLogoChange = (e) => {
        console.log(e);
        setitemSeleccionado((prevState) => ({
            ...prevState,
            logo: e
        }))
        document.getElementById("LogoBeneficiosArray").innerHTML = "Logo " + e
    }

    const AddBeneficio = async () => {
        if (itemSeleccionado.logo !== "" && itemSeleccionado.title !== "" && itemSeleccionado.categoria !== ""
            && itemSeleccionado.beneficio !== "" && itemSeleccionado.calle !== ""
            && itemSeleccionado.map !== "") {
            setLoading(true)
            const temID = uuidv4();
            const direccion = buildAddress(itemSeleccionado)
            const coordinates = await getCoordinates(direccion)
            await setDoc(doc(db, "beneficios", temID), { ...itemSeleccionado, direccion, ...coordinates });
            GetItems()
            OpenCLoseModalInsertar()
            setLoading(false)
            alert("¡Entrada creada correctamente!");


        } else {
            alert("Por favor rellena todos los campos")
        }
    }
    const DeleteBeneficio = async () => {
        setLoading(true)
        await deleteDoc(doc(db, "beneficios", editItemSeleccionado.id));
        GetItems()
        OpenCLoseModalEliminar()
        setLoading(false)
        alert("¡Producto eliminado correctamente!")

    }

    const UpdateBeneficio = async () => {
        if (itemSeleccionado.logo !== "" && itemSeleccionado.title !== "" && itemSeleccionado.categoria !== ""
            && itemSeleccionado.beneficio !== "" && itemSeleccionado.calle !== ""
            && itemSeleccionado.map !== "") {
            setLoading(true)
            const direccion = buildAddress(itemSeleccionado)
            const coordinates = await getCoordinates(direccion)
            await updateDoc(doc(db, "beneficios", editItemSeleccionado.id), { ...itemSeleccionado, direccion, ...coordinates });
            GetItems()
            OpenCLoseModalEditar()
            setLoading(false)
            alert("¡Beneficio editado correctamente!");
        }
    }

    const ExportarBeneficios = async () => {
        const snapshot = await getDocs(collection(db, "beneficios"))
        const fields = ["id", "logo", "title", "categoria", "especialidad", "beneficio", ...ADDRESS_FIELDS.map(([field]) => field), "direccion", "map", "latitud", "longitud"]
        const escape = value => `"${String(value ?? "").replace(/"/g, '""')}"`
        const rows = snapshot.docs.map(item => {
            const values = item.data()
            return fields.map(field => escape(field === "id" ? item.id : values[field])).join(",")
        })
        const csv = [fields.join(","), ...rows].join("\n")
        const link = document.createElement("a")
        link.href = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }))
        link.download = "beneficios.csv"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
    }
    const visibleData = data.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE)
    return (
        <>
            {loading && <CustomSpinner />}
            <div className="container text-center my-5 admin-module admin-module-benefits">
                <h1>Beneficios / Negocios Aliados <button className="btn text-white bg-indigo m-5" onClick={() => OpenCLoseModalInsertar()}>Nuevo beneficio</button></h1>
                <input type="button" className="btn btn-primary mb-5 me-2" value="Ver beneficio" onClick={() => GetItems()} />
                <input type="button" className="btn btn-success mb-5" value="Descargar CSV" onClick={ExportarBeneficios} />
                <input type="button" className="btn btn-secondary mb-5 ms-2" value="Ver en el mapa" onClick={() => setModalMapa(true)} disabled={!data.length} />
                {data.length > 0 ?
                    <>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Logo</th>
                                    <th>Título</th>
                                    <th>Categoría</th>
                                    <th>Especialidad</th>
                                    <th>Beneficio</th>
                                    <th>Dirección</th>
                                    <th>Link mapa</th>
                                    <th>Coordenadas</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody className="align-middle">
                                {visibleData.map((item, idx) => (
                                    <tr key={"beneficio" + idx}>
                                        <td> <ShowLogosBeneficios logoNumber={item.data().logo} /></td>
                                        <td>{item.data().title}</td>
                                        <td>{item.data().categoria || "Sin categoría"}</td>
                                        <td>{item.data().especialidad}</td>
                                        <td>{item.data().beneficio}</td>
                                        <td>{item.data().direccion}</td>
                                        <td>{item.data().map}</td>
                                        <td>{item.data().latitud && item.data().longitud ? `${item.data().latitud}, ${item.data().longitud}` : "Sin coordenadas"}</td>
                                        <td>
                                            <button className="btn btn-primary m-1" onClick={() => SeleccionarUsuario(item, "editar")}>Editar</button>
                                            <button className="btn btn-danger" onClick={() => SeleccionarUsuario(item, "eliminar")}>Eliminar</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <AdminPagination totalItems={data.length} currentPage={currentPage} onPageChange={setCurrentPage} />
                    </>
                    :
                    <div className="text-center mt-4">
                    </div>
                }
                <Modal
                    show={modalInsertar}
                    onHide={() => OpenCLoseModalInsertar()}>
                    <Modal.Header closeButton>Nuevo beneficio</Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label className="form-label">Logo</label>
                            <br />
                            <DropdownBeneficiosLogos HandleLogoChange={HandleLogoChange} />
                            <br />
                            <label className="form-label">Título</label>
                            <br />
                            <input className="form-control mb-3" type="text" name="title" onChange={HandleChange}></input>
                            <br />
                            <label className="form-label">Categoría</label>
                            <select className="form-select mb-3" name="categoria" value={itemSeleccionado.categoria} onChange={HandleChange}>
                                <option value="">Selecciona una categoría</option>
                                <option value="Salud">Salud</option><option value="Hogar">Hogar</option><option value="Educación">Educación</option>
                                <option value="Comercio">Comercio</option><option value="Bienestar">Bienestar</option><option value="Programas">Programas</option>
                            </select>
                            <br />
                            <label className="form-label">Especialidad (opcional)</label>
                            <br />
                            <input className="form-control mb-3" type="text" name="especialidad" onChange={HandleChange}></input>
                            <br />
                            <label className="form-label">Beneficio</label>
                            <br />
                            <input className="form-control mb-3" type="text" name="beneficio" onChange={HandleChange}></input>
                            <br />
                            <AddressFields value={itemSeleccionado} onChange={HandleChange} />
                            <label className="form-label">Link maps</label>
                            <br />
                            <input className="form-control mb-3" type="text" name="map" onChange={HandleChange}></input>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={() => AddBeneficio()} className="btn btn-primary">Aceptar</button>
                        <button onClick={() => OpenCLoseModalInsertar()} className="btn btn-danger">Cancelar</button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={modalEditar}
                    onHide={() => OpenCLoseModalEditar()}>
                    <Modal.Header closeButton>Editar beneficio</Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label className="form-label">Logo</label>
                            <br />
                            <DropdownBeneficiosLogos HandleLogoChange={HandleLogoChange} />
                            <br />
                            <label className="form-label">Título</label>
                            <br />
                            <input className="form-control mb-3" value={itemSeleccionado && itemSeleccionado.title} type="text" name="title" onChange={HandleChange}></input>
                            <br />
                            <label className="form-label">Categoría</label>
                            <select className="form-select mb-3" name="categoria" value={itemSeleccionado.categoria || ""} onChange={HandleChange}>
                                <option value="">Selecciona una categoría</option>
                                <option value="Salud">Salud</option><option value="Hogar">Hogar</option><option value="Educación">Educación</option>
                                <option value="Comercio">Comercio</option><option value="Bienestar">Bienestar</option><option value="Programas">Programas</option>
                            </select>
                            <br />
                            <label className="form-label">Especialidad (opcional)</label>
                            <br />
                            <input className="form-control mb-3" value={itemSeleccionado && itemSeleccionado.especialidad} type="text" name="especialidad" onChange={HandleChange}></input>
                            <br />
                            <label className="form-label">Beneficio</label>
                            <br />
                            <input className="form-control mb-3" value={itemSeleccionado && itemSeleccionado.beneficio} type="text" name="beneficio" onChange={HandleChange}></input>
                            <br />
                            <AddressFields value={itemSeleccionado} onChange={HandleChange} />
                            <label className="form-label">Link maps</label>
                            <br />
                            <input className="form-control mb-3" value={itemSeleccionado && itemSeleccionado.map} type="text" name="map" onChange={HandleChange}></input>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" onClick={() => UpdateBeneficio()} className="btn btn-primary">Editar</button>
                        <button onClick={() => OpenCLoseModalEditar()} className="btn btn-danger">Cancelar</button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={modalEliminar}
                    onHide={() => OpenCLoseModalEliminar()}>
                    <Modal.Header closeButton>Eliminar beneficio</Modal.Header>
                    <Modal.Body>
                        <div className="text-center">
                            <p>¿Estás seguro que deseas eliminar la entrada {itemSeleccionado && itemSeleccionado.title}?</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={() => DeleteBeneficio()} className="btn btn-danger">Sí</button>
                        <button onClick={() => OpenCLoseModalEliminar()} className="btn btn-primary">No</button>
                    </Modal.Footer>
                </Modal>
                <Modal show={modalMapa} onHide={() => setModalMapa(false)} fullscreen>
                    <Modal.Header closeButton>
                        <Modal.Title>Ubicación de los negocios aliados</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="admin-benefits-map-body">
                        <div ref={mapaRef} className="admin-benefits-map" />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )

}

export default BeneficiosCRUD